import { apiRecursive, ApiSmpFacecontrol } from "@smp/api";
import { Await } from "@smp/utils";
import produce from "immer";
import { WritableDraft } from "immer/dist/types/types-external";
import { useCallback } from "react";
import { useQuery, useQueryClient, UseQueryOptions } from "react-query";

const KEY = "smp.facecontrol.set";

type Response = Await<
  ReturnType<typeof ApiSmpFacecontrol.accountsStatus>
>["results"];

export const useQueryFacecontrolSet = (
  options?: Omit<UseQueryOptions<Response>, "queryKey" | "queryFn">,
) =>
  useQuery<Response>(
    KEY,
    () => apiRecursive(ApiSmpFacecontrol.accountsStatus, []),
    options,
  );

type UpdateCallback = (draft: WritableDraft<Response> | undefined) => void;

export const useQueryFacecontrolSetUpdater = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (callback: UpdateCallback) =>
      queryClient.setQueriesData<Response | undefined>(
        useQueryFacecontrolSet.KEY,
        (data) => produce(data, callback),
      ),
    [queryClient],
  );
};

useQueryFacecontrolSet.KEY = KEY;
